import React from 'react'

import { GroupTextInput } from './GroupTextInput'
import * as S from './styles'

import { FormItem } from '../FormItem'

import type { GroupTextInputProps } from './GroupTextInput'
import type { GroupInputProps } from './types'
import type { PropsWithChildren } from 'react'

/**
 *
 Example
 <GroupInput label="Length of Stay" error={errors.lengthOfStay}>
   <GroupInput.GroupTextInput
     {...register('lengthOfStayDays')}
     inputWidth="25px"
     postfix="Days"
   />
   <GroupInput.GroupTextInput
     {...register('lengthOfStayNights')}
     inputWidth="25px"
     postfix="Nights"
   />
 </GroupInput>
 * */
export const GroupInput: React.FC<PropsWithChildren<GroupInputProps>> & {
  GroupTextInput: React.FC<GroupTextInputProps>
} = ({
  error,
  label,
  shouldKeepLabelSpacing,
  hidden,
  readOnly = false,
  children,
}) => (
  <FormItem
    shouldKeepLabelSpacing={shouldKeepLabelSpacing}
    label={label}
    error={error}
    hidden={hidden}
  >
    <S.GroupWrapper $error={error} $readOnly={readOnly}>
      {children}
    </S.GroupWrapper>
  </FormItem>
)
GroupInput.GroupTextInput = GroupTextInput
GroupInput.displayName = 'GroupInput'
